function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#4stars_svg__clip0_1_14)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 12.282l-4.945 2.935L4.32 9.608 0 5.813l5.725-.531L8 0l2.274 5.282L16 5.813l-4.32 3.795 1.265 5.61L8 12.281zm1.854-.782v-1.098h.729V9.043h-.729V5.497H7.703L5.426 9.196v1.206h2.871V11.5h1.557zM8.297 9.043H6.929l1.368-2.196v2.196z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "4stars_svg__clip0_1_14"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function Svg4Stars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default Svg4Stars;